export { ActivateUser as default } from './activate-user';
